import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/popup.scss";

const ViewMaterialPopup = ({ open, handleClose, material }) => {
  const [imageError, setImageError] = useState({});
  const [audioError, setAudioError] = useState({});
  const [pptViewer, setPptViewer] = useState("office");
  const [contentItems, setContentItems] = useState([]);

  React.useEffect(() => {
    if (material && material.content && Array.isArray(material.content)) {
      const mappedContent = material.content.map((item) => ({
        content: item.content,
        type:
          item.type || material.material_type || material.materials_type || "",
        id: item.id || "",
        sequence: item.sequence || 0,
      }));
      setContentItems(mappedContent);
    } else if (material && material.content) {
      setContentItems([material.content]);
    } else {
      setContentItems([]);
    }
  }, [material]);

  const handleRemoveItem = (index) => {
    const newItems = contentItems.filter((_, i) => i !== index);
    setContentItems(newItems);
  };

  const renderSingleContent = (contentItem, index, showRemove = false) => {
    const link =
      typeof contentItem === "string" ? contentItem : contentItem.content;
    const isBlobUrl = typeof link === "string" && link.startsWith("blob:");
    const type = (
      contentItem.type ||
      material.materials_type ||
      material.material_type ||
      ""
    ).toLowerCase();
    const name = material.name || "";
    const sequence = contentItem.sequence || 0;
    const itemName = sequence > 1 ? `${name} (Page ${sequence})` : name;

    const isVideo = type === "video" || type === "videos";
    const isPdf = type === "pdf";
    const isAudio = type === "audio" || type === "audios";
    const isImage = type === "image" || type === "images";
    const isPpt = type === "ppt" || type === "pptx" || type === "presentation";

    const isYouTubeLink =
      typeof link === "string" &&
      (link.includes("youtube.com") || link.includes("youtu.be"));

    const getDrivePreviewUrl = (rawUrl) => {
      if (typeof rawUrl !== "string" || !rawUrl) return null;
      try {
        const url = new URL(rawUrl);
        const host = url.hostname || "";

        const isDriveHost = host.includes("drive.google.com");
        const isDocsHost = host.includes("docs.google.com");
        if (!isDriveHost && !isDocsHost) return null;

        let id = url.searchParams.get("id");
        if (!id) {
          const match = url.pathname.match(/\/d\/([^/]+)/);
          if (match && match[1]) id = match[1];
        }
        if (!id) return null;

        if (isDocsHost) {
          const typeMatch = url.pathname.match(
            /^\/(document|presentation|spreadsheets|forms)\/d\//,
          );
          const docType = typeMatch ? typeMatch[1] : null;
          if (docType) {
            return `https://docs.google.com/${docType}/d/${id}/preview`;
          }
        }

        return `https://drive.google.com/file/d/${id}/preview`;
      } catch (e) {
        return null;
      }
    };

    const drivePreviewUrl = getDrivePreviewUrl(link);

    let youtubeEmbedUrl = null;
    if (isYouTubeLink) {
      try {
        if (link.includes("youtube.com/watch")) {
          const url = new URL(link);
          const v = url.searchParams.get("v");
          if (v) {
            youtubeEmbedUrl = `https://www.youtube.com/embed/${v}`;
          }
        } else if (link.includes("youtu.be/")) {
          const id = link.split("youtu.be/")[1]?.split(/[?&#]/)[0];
          if (id) {
            youtubeEmbedUrl = `https://www.youtube.com/embed/${id}`;
          }
        }
      } catch (e) {
        youtubeEmbedUrl = null;
      }
    }

    return (
      <div
        key={index}
        className="content-item"
        style={{ position: "relative", marginBottom: "20px" }}
      >
        {showRemove && (
          <button
            onClick={() => handleRemoveItem(index)}
            className="remove-button"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "#ff4444",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: "24px",
              height: "24px",
              cursor: "pointer",
              zIndex: 10,
            }}
          >
            ×
          </button>
        )}

        {contentItems.length > 1 && (
          <h4
            style={{
              marginBottom: "10px",
              fontSize: "14px",
              fontWeight: "600",
            }}
          >
            {itemName}
          </h4>
        )}

        {isVideo && link && youtubeEmbedUrl && (
          <iframe
            title={itemName || "Video"}
            src={youtubeEmbedUrl}
            style={{
              width: "100%",
              height: contentItems.length > 1 ? "250px" : "300px",
              border: "none",
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        )}

        {isVideo && link && !youtubeEmbedUrl && drivePreviewUrl && (
          <iframe
            title={itemName || "Video"}
            src={drivePreviewUrl}
            style={{
              width: "100%",
              height: contentItems.length > 1 ? "250px" : "300px",
              border: "none",
            }}
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        )}

        {isVideo && link && !youtubeEmbedUrl && !drivePreviewUrl && (
          <video
            controls
            style={{
              width: "100%",
              maxHeight: contentItems.length > 1 ? "250px" : "300px",
              borderRadius: 8,
            }}
          >
            <source src={link} />
            Your browser does not support the video tag.
          </video>
        )}

        {isPdf &&
          link &&
          (isBlobUrl ? (
            <iframe
              title={itemName || "PDF"}
              src={link}
              style={{
                width: "100%",
                height: contentItems.length > 1 ? "350px" : "300px",
                border: "none",
              }}
            />
          ) : link.toLowerCase().includes(".pdf") || drivePreviewUrl ? (
            <iframe
              title={itemName || "PDF"}
              src={link.toLowerCase().includes(".pdf") ? link : drivePreviewUrl}
              style={{
                width: "100%",
                height: contentItems.length > 1 ? "350px" : "300px",
                border: "none",
              }}
            />
          ) : (
            <div>
              <p>This material is a invalid link.</p>
            </div>
          ))}

        {isAudio && link && !audioError[index] && (
          <audio
            controls
            style={{ width: "100%", marginTop: "20px" }}
            onError={() =>
              setAudioError((prev) => ({ ...prev, [index]: true }))
            }
          >
            <source src={link} />
            Your browser does not support the audio element.
          </audio>
        )}

        {isAudio && audioError[index] && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p>Unable to play audio. The file might not be accessible.</p>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                marginTop: "10px",
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "white",
                textDecoration: "none",
                borderRadius: "4px",
              }}
            >
              Download Audio File
            </a>
          </div>
        )}

        {isImage && link && !imageError[index] && (
          <img
            src={link}
            alt={itemName || "Image"}
            style={{
              maxWidth: "100%",
              maxHeight: contentItems.length > 1 ? "250px" : "300px",
              borderRadius: 8,
              objectFit: "contain",
            }}
            onError={() =>
              setImageError((prev) => ({ ...prev, [index]: true }))
            }
          />
        )}

        {isImage && imageError[index] && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p>Unable to load image. The file might not be accessible.</p>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                marginTop: "10px",
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "white",
                textDecoration: "none",
                borderRadius: "4px",
              }}
            >
              Open Image in New Tab
            </a>
          </div>
        )}

        {isPpt &&
          link &&
          (isBlobUrl ? (
            <iframe
              title={name || "Presentation"}
              src={link}
              style={{ width: "100%", height: "300px", border: "none" }}
              allowFullScreen
            />
          ) : drivePreviewUrl ? (
            <iframe
              title={name || "Presentation"}
              src={drivePreviewUrl}
              style={{ width: "100%", height: "300px", border: "none" }}
              allowFullScreen
            />
          ) : (
            <div style={{ height: "300px", width: "100%" }}>
              {pptViewer === "office" && (
                <iframe
                  title={name || "Presentation"}
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    link,
                  )}`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  onError={() => setPptViewer("google")}
                />
              )}

              {pptViewer === "google" && (
                <iframe
                  title={name || "Presentation"}
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    link,
                  )}&embedded=true`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  onError={() => setPptViewer("failed")}
                />
              )}

              {pptViewer === "failed" && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                  <p>
                    <strong>{name || "Presentation"}</strong>
                  </p>
                  <p>Preview not available for this presentation.</p>
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "10px",
                      padding: "10px 20px",
                      backgroundColor: "#007bff",
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "4px",
                    }}
                  >
                    Download Presentation
                  </a>
                </div>
              )}
            </div>
          ))}

        {!link && <div>No content URL configured for this material.</div>}
      </div>
    );
  };

  if (!open || !material) return null;

  const name = material.name || "";

  return createPortal(
    <div
      className={`common-popup-overlay ${open ? "" : "hidden"} high-z-index`}
      onClick={handleClose}
    >
      <div
        className="common-popup-container markdown-editor-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header with-close">
          <h2>{name || "View Material"}</h2>
          <button
            type="button"
            className="popup-close-button"
            onClick={handleClose}
          >
            ×
          </button>
        </div>

        <div className="popup-content">
          {contentItems.length > 1 ? (
            <div
              className="multi-content-container"
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              {contentItems
                .sort((a, b) => (a.sequence || 0) - (b.sequence || 0))
                .map((item, index) => renderSingleContent(item, index, true))}
            </div>
          ) : contentItems.length === 1 ? (
            renderSingleContent(contentItems[0], 0, false)
          ) : (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <p style={{ fontSize: "16px", color: "var(--color-text-light)" }}>
                No content available for this material.
              </p>
              <p
                style={{
                  fontSize: "14px",
                  color: "var(--color-text-light)",
                  marginTop: "8px",
                }}
              >
                {material.material_type === "video" &&
                  "Add video content to get started."}
                {material.material_type === "pdf" &&
                  "Add PDF content to get started."}
                {material.material_type === "image" &&
                  "Add image content to get started."}
                {material.material_type === "audio" &&
                  "Add audio content to get started."}
                {material.material_type === "ppt" &&
                  "Add presentation content to get started."}
                {!material.material_type && "Add content to get started."}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ViewMaterialPopup;
